module.exports = __webpack_public_path__ + "img/2026-03-24a_1.3169414d.jpg";